import { AcceptProviderOffer , SubmitPostService} from '@/api/endpoints/Broker/BrokerRequest';
import { STATUS_MAP } from '@/data/status';
import { usePayment } from '@/hooks/usePayment';
import { LS } from '@/utils/localStorage';
import moment from 'moment';
import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom';

const PAYMENTOPTIONSTPYE = {
    DOWN_PAYMENT: [  STATUS_MAP.AwaitingInitialPayment],
    FULL_PAYMENT: [STATUS_MAP.TreatmentCompleted , STATUS_MAP.PreparingForTreatment ,STATUS_MAP.TreatmentInProgress, STATUS_MAP.PaymentCompleted],
    QUOTATION_READY: STATUS_MAP.QuotationAvailable,
}


const usePayement = ({ selectedAddOns, quotationData, downPayment, selectedPostServices, scheduledDate }) => {

    const { handlePay, paymentLoading, setPaymentLoading } = usePayment();

    const { medicalOrderId, hospitlaOrderId } = useParams();


    const [isAgreeToTerms, setIsAgreeToTerms] = useState(PAYMENTOPTIONSTPYE.QUOTATION_READY != quotationData?.orderStatusId);

    const isDisabled = useMemo(() =>
       ( paymentLoading ||
        (!isAgreeToTerms && (!scheduledDate || !quotationData?.patientSelectedDate)) ||
        (!scheduledDate && !quotationData?.patientSelectedDate) ||
        (!quotationData?.pendingPaymentAmount && !!quotationData.paidPrice) && !selectedPostServices.length)
        , [scheduledDate, quotationData, isAgreeToTerms, paymentLoading]);


    const handleDownPayment = () => {
        LS.removeItem('sPS');
        handlePay(quotationData?.orderId, medicalOrderId, downPayment || quotationData?.pendingPaymentAmount)
    }

    const handleFullPayment = () => {
        setPaymentLoading(true);

        SubmitPostService(hospitlaOrderId, { postServicesIds: selectedPostServices }).then((res: any) => {
            handlePay(quotationData?.orderId, medicalOrderId, downPayment || quotationData?.pendingPaymentAmount)
            LS.removeItem('sPS');
        })
    }

    const handleQuotationReady = useCallback(() => {
        setPaymentLoading(true);

        AcceptProviderOffer(hospitlaOrderId, {
            date: moment(scheduledDate||null).format("YYYY-MM-DD"),
            addOnsIds: selectedAddOns || [],
        }).then((res: any) => {
            handlePay(quotationData?.orderId, medicalOrderId, downPayment || quotationData?.pendingPaymentAmount)
        }).catch((err: any) => {
            console.log(err)
            setPaymentLoading(false)
        })
    }, [scheduledDate, selectedAddOns, quotationData, medicalOrderId, hospitlaOrderId, downPayment])

    const onPay = useMemo(() => {
        if (PAYMENTOPTIONSTPYE.DOWN_PAYMENT.includes(quotationData?.orderStatusId)) return () => handleDownPayment();
        if (PAYMENTOPTIONSTPYE.FULL_PAYMENT.includes(quotationData?.orderStatusId)) return () => handleFullPayment();
        if (PAYMENTOPTIONSTPYE.QUOTATION_READY == quotationData?.orderStatusId) return () => handleQuotationReady();
    }, [quotationData, scheduledDate])

    return { onPay, loading: paymentLoading, isAgreeToTerms, isDisabled, setIsAgreeToTerms }
}

export default usePayement